import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Marsa_Al_Seef.webp';

const Project_one = () => {

  return (
   <>
   
         <div className='project_1_work' id="workBanner">
   
           <div className="container project_our_work">
   
             <div className="heading">
               <h1>Marsa Al Seef</h1>
             </div>
   
             <hr></hr>
             <div className='project_section'>
               <div className="project_section_content">
                 <h1 className="project_scope">Scope of Work</h1>
                 <p>A heritage-inspired waterfront promenade and hospitality development along Dubai Creek, developed by Meraas. Marsa Al
                    Seef recreates the character of historic Dubai through traditional architecture, retail, dining and boutique hotel experiences
                    along the Creek.</p>
                 <p>MAIN CONTRACTOR : -</p>
                 <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
                 <p>GEMCO SCOPE OF WORKS : CHW and ducting works</p>
                 {/* <h2 className="project_years">2014 – 2022</h2> */}
               </div>
               <div className='project_1_card'>
                 <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
               </div>
             </div>
           </div>
         </div>
   
       </>

  )
}

export default Project_one